import './components/css/style.css'
import './components/css/responsive.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './components/Pages/Home';
import Pricelist from './components/Pages/Pricelist';
function App() {

  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path='/:mobileNum' element={<Pricelist />} />
          <Route path='/' element={<Pricelist />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
